/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * (tsType: Omit<ModuleAccess, \'id\'>, schemaOptions: { title: \'NewModuleAccess\', exclude: [ \'id\' ] })
 */
export interface NewModuleAccess { 
    deleted?: boolean;
    deletedOn?: string | null;
    deletedBy?: string | null;
    createdOn?: string;
    modifiedOn?: string;
    createdBy?: number;
    modifiedBy?: number;
    isAllowed?: boolean;
    userId?: number;
    companyId?: string;
    modulePermissionId?: string;
    /**
     * Acceso por rol; sin usuario, rol ni compañía el acceso es global
     */
    roleId?: number | null;
    /**
     * Plataforma a la que aplica; null = todas
     */
    platform?: NewModuleAccess.PlatformEnum | null;
    /**
     * Inicio de vigencia; null = desde siempre
     */
    startsOn?: string | null;
    /**
     * Fin de vigencia; null = sin fin
     */
    endsOn?: string | null;
    /**
     * Motivo del acceso o la denegación
     */
    reason?: string | null;
}
export namespace NewModuleAccess {
    export type PlatformEnum = 'web' | 'ios' | 'android' | 'null';
    export const PlatformEnum = {
        Web: 'web' as PlatformEnum,
        Ios: 'ios' as PlatformEnum,
        Android: 'android' as PlatformEnum,
        Null: 'null' as PlatformEnum
    };
}


